'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _operatorDecorator = require('./operator-decorator');

var _operatorDecorator2 = _interopRequireDefault(_operatorDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperatorDecorators = [];

OperatorDecorators.push(new _operatorDecorator2.default('someFact', function (factValue, jsonValue, next) {
  return factValue.some(function (fv) {
    return next(fv, jsonValue);
  });
}, Array.isArray));
OperatorDecorators.push(new _operatorDecorator2.default('someValue', function (factValue, jsonValue, next) {
  return jsonValue.some(function (jv) {
    return next(factValue, jv);
  });
}));
OperatorDecorators.push(new _operatorDecorator2.default('everyFact', function (factValue, jsonValue, next) {
  return factValue.every(function (fv) {
    return next(fv, jsonValue);
  });
}, Array.isArray));
OperatorDecorators.push(new _operatorDecorator2.default('everyValue', function (factValue, jsonValue, next) {
  return jsonValue.every(function (jv) {
    return next(factValue, jv);
  });
}));
OperatorDecorators.push(new _operatorDecorator2.default('swap', function (factValue, jsonValue, next) {
  return next(jsonValue, factValue);
}));
OperatorDecorators.push(new _operatorDecorator2.default('not', function (factValue, jsonValue, next) {
  return !next(factValue, jsonValue);
}));

exports.default = OperatorDecorators;